<script setup lang="ts">
import type { OperationalPeriod } from '@/types'

const props = defineProps<{
  ops: OperationalPeriod[]
  modelValue: string | null
}>()

const emit = defineEmits<{
  'update:modelValue': [opId: string]
}>()

function formatDate(date: string) {
  if (!date) return ''
  // date is stored as YYYY-MM-DD
  const [y, m, d] = date.split('-')
  return `${m}/${d}/${y}`
}
</script>

<template>
  <div class="flex gap-2 overflow-x-auto pb-1">
    <button
      v-for="op in ops"
      :key="op.op_id"
      type="button"
      class="flex-shrink-0 rounded-lg border-2 px-4 py-2 text-sm font-medium focus:outline-none"
      :class="
        modelValue === op.op_id
          ? 'border-orange-500 bg-orange-500/10 text-orange-600 dark:text-orange-400'
          : 'border-border bg-surface-container text-on-surface-variant hover:bg-surface-container-high hover:border-outline'
      "
      @click="emit('update:modelValue', op.op_id)"
    >
      <div class="font-semibold">OP {{ op.op_number }}</div>
      <div class="text-xs opacity-75">{{ formatDate(op.date) }}</div>
    </button>

    <div v-if="ops.length === 0" class="text-sm text-outline-variant py-2">
      No operational periods yet
    </div>
  </div>
</template>
